import { FC } from "react";

import { IRichLogData } from "@ryde/shared";

import { RichLogsFilters } from "../../rich-logs-components";

interface IEtlLogFilters {
  logData: IRichLogData | undefined;
  hasExternalLogs?: boolean;
}

export const EtlLogsFilters: FC<IEtlLogFilters> = ({
  logData,
  hasExternalLogs,
}) => {
  return (
    <RichLogsFilters
      isFinished
      logData={logData}
      hasExternalLogs={hasExternalLogs}
      isStatsCollapsed={false}
    ></RichLogsFilters>
  );
};
